import { Loader as LoaderIcon } from '../../../icons';

export const Loader = () => {
    return (
        <div role="status">
            <LoaderIcon />
            <span className="sr-only">Loading...</span>
        </div>
    );
};
